var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2490,
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 256 255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "84.75%",
    x2: "58.254%",
    y1: "111.399%",
    y2: "64.584%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FB7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FB7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "41%",
    stopColor: "#E42B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "116.651%",
    x2: "1.746%",
    y1: "60.89%",
    y2: "19.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "75.774%",
    x2: "38.978%",
    y1: "219.327%",
    y2: "7.829%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50.012%",
    x2: "66.483%",
    y1: "7.234%",
    y2: "79.135%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "23%",
    stopColor: "#E57252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "46%",
    stopColor: "#DE3B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#A60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A60003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "46.174%",
    x2: "49.932%",
    y1: "16.348%",
    y2: "83.047%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "23%",
    stopColor: "#E4714E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "56%",
    stopColor: "#BE1A0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A80D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "36.965%",
    x2: "49.528%",
    y1: "15.594%",
    y2: "92.478%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    stopColor: "#E46342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#C82410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A80D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "13.609%",
    x2: "85.764%",
    y1: "58.346%",
    y2: "-46.717%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "#C81F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#BF0905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BF0905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "27.624%",
    x2: "50.745%",
    y1: "21.135%",
    y2: "79.056%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "31%",
    stopColor: "#DE4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#BF190B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BF190B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "-20.667%",
    x2: "104.242%",
    y1: "122.282%",
    y2: "-6.342%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BD0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BD0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "7%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "17%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "27%",
    stopColor: "#C82F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "33%",
    stopColor: "#820C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "46%",
    stopColor: "#A31601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72%",
    stopColor: "#B31301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#E82609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E82609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "58.792%",
    x2: "11.964%",
    y1: "65.205%",
    y2: "50.128%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8C0C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8C0C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "#990C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#A80D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A80D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "79.319%",
    x2: "23.088%",
    y1: "62.754%",
    y2: "17.888%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7E110B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7E110B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#9E0C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9E0C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "92.88%",
    x2: "59.841%",
    y1: "74.122%",
    y2: "39.704%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#79130D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#79130D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#9E120B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9E120B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: "56.57%",
    x2: "3.105%",
    y1: "101.717%",
    y2: "11.993%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8B2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8B2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43%",
    stopColor: "#9E100A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#B3100C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B3100C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: "30.87%",
    x2: "92.471%",
    y1: "35.599%",
    y2: "100.694%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "44%",
    stopColor: "#910F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#791C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#791C12"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: "32.001%",
    cy: "40.21%",
    r: "69.573%",
    fx: "32.001%",
    fy: "40.21%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#7E0E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7E0E08"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: "13.549%",
    cy: "40.86%",
    r: "88.386%",
    fx: "13.549%",
    fy: "40.86%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A30C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A30C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#800E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#800E08"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m197.467 167.764-145.52 86.41 188.422-12.787L254.88 51.393l-57.414 116.37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M240.677 241.257 224.482 129.48l-44.113 58.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m240.896 241.257-118.646-9.313-69.674 21.986z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m52.744 253.955 29.64-97.1L17.16 170.8l35.583 83.154z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M180.358 188.05 153.085 81.226l-78.047 73.16 105.32 33.666z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m248.693 82.73-73.777-60.256-20.544 66.418z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M214.191.99 170.8 24.97 143.424.669l70.767.322z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m0 203.372 18.177-33.151-14.704-39.494z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m2.496 129.48 14.794 41.963 64.283-14.422 73.39-68.207 20.712-65.787L143.063 0 87.618 20.75c-17.469 16.248-51.366 48.396-52.588 49-1.21.618-22.384 40.639-32.534 59.73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M54.442 54.094c37.86-37.538 86.667-59.716 105.397-40.818 18.72 18.898-1.132 64.823-38.992 102.349-37.86 37.525-86.062 60.925-104.78 42.027-18.73-18.885.515-66.032 38.375-103.558"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m52.744 253.916 29.408-97.409 97.665 31.376c-35.312 33.113-74.587 61.106-127.073 66.033"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m155.092 88.622 25.073 99.313c29.498-31.016 55.972-64.36 68.938-105.603l-94.01 6.29z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M248.847 82.833c10.035-30.282 12.35-73.725-34.966-81.791l-38.825 21.445z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E1209",
    d: "M0 202.935c1.39 49.979 37.448 50.724 52.808 51.162l-35.48-82.86z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M155.232 88.777c22.667 13.932 68.35 41.912 69.276 42.426 1.44.81 19.695-30.784 23.838-48.64z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m82.113 156.507 39.313 75.848c23.246-12.607 41.45-27.967 58.121-44.42z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m17.174 171.34-5.57 66.328c10.51 14.357 24.97 15.605 40.136 14.486-10.973-27.311-32.894-81.92-34.566-80.814"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m174.826 22.654 78.1 10.96c-4.169-17.662-16.969-29.06-38.787-32.623z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.7a029fb99a9a01f6b79bc351d0516e74.svg";
export { ForwardRef as ReactComponent };